import { render, staticRenderFns } from "./DisableAccount.vue?vue&type=template&id=f8affdaa&scoped=true&"
import script from "./DisableAccount.vue?vue&type=script&lang=js&"
export * from "./DisableAccount.vue?vue&type=script&lang=js&"
import style0 from "./DisableAccount.vue?vue&type=style&index=0&id=f8affdaa&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-2fffd51942/0/cache/vue-loader-npm-15.9.3-4ca89c7e4b-bc7d4c63e0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8affdaa",
  null
  
)

export default component.exports